import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Outlet } from 'react-router';

const MenuReplayContext = createContext(null);

/**
 * 메뉴에서 이미 보고 있는 경로를 다시 눌렀을 때,
 * 해당 화면을 초기 상태로 만들기 위해 라우트를 리마운트할 때 사용합니다.
 */
export function MenuReplayProvider({ children }) {
  const [replayNonce, setReplayNonce] = useState(0);
  const bumpMenuReplay = useCallback(() => setReplayNonce((n) => n + 1), []);
  const value = useMemo(() => ({ replayNonce, bumpMenuReplay }), [replayNonce, bumpMenuReplay]);
  return <MenuReplayContext.Provider value={value}>{children}</MenuReplayContext.Provider>;
}

export function useMenuReplay() {
  const ctx = useContext(MenuReplayContext);
  if (!ctx) {
    throw new Error('useMenuReplay must be used within MenuReplayProvider');
  }
  return ctx;
}

/** 하위 매칭 라우트를 replayNonce 변경 시 리마운트 */
export function MenuReplayLayout() {
  const { replayNonce } = useMenuReplay();
  return <Outlet key={replayNonce} />;
}
